// extracted by mini-css-extract-plugin
export default {"ToggleSwitch":"_ToggleSwitch--LN8Qh","Disabled":"_Disabled--PJVdR","Label":"_Label--FhsC4","Slider":"_Slider--Z6SGE","Toggled":"_Toggled--UvIVV"};